import { defineMessage, defineMessages } from "react-intl";

import DealLockReason from "@app/enum/DealLockReason";

const dealLockMessages = defineMessages<DealLockReason>({
  [DealLockReason.FUNNEL_LOCKED]: {
    id: "deal.lock.note.funnelLocked",
    defaultMessage: "Deals in this funnel can't be moved between stages or deleted",
    description:
      "Short note on a deal whose funnel is locked against stage moves and deletes (other fields stay editable)",
  },
  [DealLockReason.STAGE_READ_ONLY]: {
    id: "deal.lock.note.stageReadOnly",
    defaultMessage: "Deals in this stage are read-only",
    description: "Short note on a deal whose stage makes it read-only",
  },
});

// The id keeps the Field Agent card's prefix: that card is the one place a create is blocked.
export const newDealLockedMessage = defineMessage({
  id: "chat.message.proposals.blocked.dealCreateLocked",
  defaultMessage: "New deals can't be added to a locked funnel or a read-only stage",
  description:
    "Tooltip on a create_record proposal's disabled Confirm button or disabled checkbox when the proposed deal's funnel is locked or its stage is read-only",
});

// No deal can be moved into a read-only stage, wherever it sits now.
export const moveIntoReadOnlyStageMessage = defineMessage({
  id: "deal.lock.note.moveIntoReadOnlyStage",
  defaultMessage: "Deals can't be moved into a read-only stage",
  description:
    "Tooltip on a Field Agent proposal's disabled Confirm when it would move a deal into a read-only stage",
});

export const moveIntoLockedFunnelMessage = defineMessage({
  id: "deal.lock.note.moveIntoLockedFunnel",
  defaultMessage: "Deals can't be moved into a locked funnel",
  description:
    "Tooltip on a Field Agent proposal's disabled Confirm when it would move a deal into a locked funnel",
});

export default dealLockMessages;
